import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@docs/kd-d2c-components';
import { eed_mario_icon_review_area } from '@src/assets/icons';
import './auditButton.less';
import intl from '@/internationalzation/intl';

const DEFAULT_NAME = 'mario-audit-button';

export const AuditButton = () => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate('/mario?audit=1');
  };
  return (
    <div className={`${DEFAULT_NAME}`} onClick={onClick}>
      <div className={`${DEFAULT_NAME}-icon`}>
        <Icon
          icon={eed_mario_icon_review_area}
          size={18}
          color="var(--color-text-primary)"
        />
        <div className={`${DEFAULT_NAME}-icon-text`}>{intl.t('审计模式')}</div>
      </div>
      <div className={`${DEFAULT_NAME}-divider`}></div>
    </div>
  );
};
